import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '../http/authentication.service';
import { Logger } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckerService {
  public _authenticationService = inject(AuthenticationService);

  public _logger = inject(Logger);

  public hasRequiredBauplusVersion(minVersion: string): boolean {
    if (!this._authenticationService.currentUserValue) {
      this._logger.error('Kein Benutzer angemeldet, kann Bauplus-Version nicht prüfen');
      return false;
    }

    const bauplusVersion = this._authenticationService.currentUserValue.bauPlusVersion;
    const partsBauplusVersion = bauplusVersion.split('.');
    if (partsBauplusVersion.length !== 4) {
      this._logger.error('Bauplus-Version ungültig: ' + bauplusVersion);
      return false;
    }

    const partsMinVersion = minVersion.split('.');
    if (partsMinVersion.length !== 4) {
      this._logger.error('Min-Version ungültig: ' + minVersion);
      return false;
    }

    if (bauplusVersion === '1.0.0.0') {
      return true;
    }

    return this.compareVersions(partsBauplusVersion, partsMinVersion) >= 0;
  }

  private compareVersions(partsBauplusVersion: string[], partsMinVersion: string[]) {
    // Major
    if (+partsBauplusVersion[0] !== +partsMinVersion[0]) {
      return +partsBauplusVersion[0] > +partsMinVersion[0] ? 1 : -1;
    }
    // Minor
    if (+partsBauplusVersion[1] !== +partsMinVersion[1]) {
      return +partsBauplusVersion[1] > +partsMinVersion[1] ? 1 : -1;
    }
    // Build
    if (+partsBauplusVersion[2] !== +partsMinVersion[2]) {
      return +partsBauplusVersion[2] > +partsMinVersion[2] ? 1 : -1;
    }
    // Revision
    if (+partsBauplusVersion[3] === +partsMinVersion[3]) {
      return 0;
    }

    return +partsBauplusVersion[3] > +partsMinVersion[3] ? 1 : -1;
  }
}
